import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import WhitePassport from "../images/ESN black_passport.png";
import { getProfile } from "../../core/store/actions/auth";
import "../../styles/messagePage.css";
import { Icon } from '@iconify/react/dist/iconify.js';
import { useAuth } from '../../core/AuthContext';
import { logoutUser } from '../../core/store/actions/auth';
import {
  FORMER_MEMBER_PLATFORM_MESSAGE,
  hasPlatformAccess,
  isFormerMember,
} from '../../core/utils/permissionUtils';

function PlatformAccessRevoked() {
    const dispatch = useDispatch();
    const history = useHistory();

    useAuth();

    const user = useSelector((state) => state.user);

    const handleRefresh = () => {
        dispatch(getProfile());
    };

    const handleLogout = () => {
        dispatch(logoutUser());
        history.push("/main");
    };

    useEffect(() => {
        if (hasPlatformAccess(user?.profile)) {
            history.push("/main");
            return;
        }
        if (user?.profile && !isFormerMember(user.profile)) {
            history.push("/waiting-for-hr");
        }
    }, [user, history]);

    return (
        <div className="error-message-container">
            <h3 className="error-message-title">Access ended</h3>
            <img src={WhitePassport} alt="Black Passport" className="error-image" />
            <p className="error-message">
                {FORMER_MEMBER_PLATFORM_MESSAGE}
            </p>
            <button className="button" style={{ marginTop: '20px' }} onClick={handleRefresh}>
                Refresh
            </button>

            <button style={{border:"none", background:"none", display:"flex", flexDirection:"row", alignContent:"center", margin:"10px"}} onClick={handleLogout}>
              <Icon icon="fluent:arrow-exit-20-filled" width="1.5em" height="1.5em" style={{ marginRight: '10px' }} />
              Log Out
            </button>
        </div>
    );
}

export default PlatformAccessRevoked;
